module.exports = function _of(x) { return [x]; };



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_of.js
// module id = 297
// module chunks = 34471704633725 35783957827783 114276838955818 216468464745311